export const RaceSeries = "RaceSeries"
export const Races = "Races"